import { NewsNews } from 'api/models'

export interface NewsState {
  news: NewsNews[]
  newsTotal: number
  item: NewsNews | null
  loading: boolean
  error: null | string
}
export enum NewsActionTypes {
  FETCH_NEWS = 'FETCH_NEWS',
  FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS',
  FETCH_NEWS_SUCCESS_MORE = 'FETCH_NEWS_SUCCESS_MORE',
  FETCH_NEWS_ERROR = 'FETCH_NEWS_ERROR',
  FETCH_ITEM_NEWS = 'FETCH_ITEM_NEWS',
  FETCH_ITEM_NEWS_SUCCESS = 'FETCH_ITEM_NEWS_SUCCESS',
}
interface FetchNewsAction {
  type: NewsActionTypes.FETCH_NEWS | NewsActionTypes.FETCH_ITEM_NEWS
}
interface FetchNewsSuccessAction {
  type:
    | NewsActionTypes.FETCH_NEWS_SUCCESS
    | NewsActionTypes.FETCH_NEWS_SUCCESS_MORE
  payload: { items: NewsNews[]; total: number }
}
interface FetchNewsItemSuccessAction {
  type: NewsActionTypes.FETCH_ITEM_NEWS_SUCCESS
  payload: NewsNews
}
interface FetchNewsErrorAction {
  type: NewsActionTypes.FETCH_NEWS_ERROR
  payload: string
}
export type NewsAction =
  | FetchNewsAction
  | FetchNewsSuccessAction
  | FetchNewsItemSuccessAction
  | FetchNewsErrorAction
